// Helpers for fuzzy location matching + date arithmetic
// Used across customer pages so car-location strings (e.g. "Santo Domingo Downtown")
// correctly match canonical location names (e.g. "Santo Domingo").

export const normLoc = (s) =>
  String(s || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

/** Loose location match: equal, or one contains the other. */
export const matchesLocation = (carLoc, locName) => {
  const a = normLoc(carLoc);
  const b = normLoc(locName);
  if (!a || !b) return false;
  if (a === b) return true;
  if (a.includes(b) || b.includes(a)) return true;
  return false;
};

export const addDays = (dateStr, n) => {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const daysBetween = (a, b) => {
  const d1 = new Date(a);
  const d2 = new Date(b);
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return 0;
  return Math.round((d2 - d1) / 86400000);
};

/** Ensure dropoffDate is at least `minDays` after pickupDate.
 *  Returns the (possibly updated) dropoffDate. */
export const ensureMinDays = (pickupDate, dropoffDate, minDays) => {
  const m = Math.max(1, Number(minDays) || 1);
  const cur = daysBetween(pickupDate, dropoffDate);
  if (cur >= m) return dropoffDate;
  return addDays(pickupDate, m);
};
